import React from 'react';
import {
  Typography,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import { currency } from './currency';

// ----------------------------------------------------------------------
// StatementTable — the giving-history table (or its "nothing to show"
// message) for a set of transactions. Shared by the on-screen statement
// view in MyAccount.js and the print-only copy in GivingStatementPrint,
// so the two can never drift out of sync with each other.
// ----------------------------------------------------------------------
export default function StatementTable({
  transactions,
  statementYear,
  donationTotal,
  paymentTotal,
}) {
  if (transactions.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ mt: 3 }}>
        No giving recorded{statementYear === 'all' ? '' : ` in ${statementYear}`}.
      </Typography>
    );
  }

  return (
    <>
      <Table size="small" sx={{ mt: 3, background: '#fff' }}>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Reference</TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((t) => {
            const isDonation = t.type === 'donation';
            return (
              <TableRow key={t.id}>
                <TableCell>{t.date}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={isDonation ? 'Donation' : 'Payment'}
                    color={isDonation ? 'success' : 'default'}
                  />
                </TableCell>
                <TableCell>{t.reference || t.memo || '—'}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: isDonation ? 'success.main' : 'text.secondary' }}
                >
                  {isDonation ? currency(t.amount) : `(${currency(t.amount)})`}
                </TableCell>
              </TableRow>
            );
          })}
          <TableRow>
            <TableCell colSpan={3} sx={{ fontWeight: 700 }}>
              Total donations
              {statementYear === 'all' ? '' : ` for ${statementYear}`}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: 'success.main' }}>
              {currency(donationTotal)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3} sx={{ fontWeight: 700 }}>
              Total payments
              {statementYear === 'all' ? '' : ` for ${statementYear}`}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: 'text.secondary' }}>
              ({currency(paymentTotal)})
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Typography
        variant="body2"
        color="text.secondary"
        className="statement-footer"
        sx={{ mt: 2 }}
      >
        Please retain this statement for your tax records.
      </Typography>
    </>
  );
}
